import React from "react";
import { ReactComponent as SearchIcon } from "../../../common/assets/search.svg";
import {
  MissionListActionsInput,
  MissionListActionsInputContent,
  MissionListActionsSearchBox,
  MissionListActionsSearchContainer,
  MissionListActionsSearchIconShape,
  MissionListActionsSearchIconWrapper,
  MissionListActionsStateOverlay,
} from "./MissionListActions.styles";

interface MissionListSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onSearch?: (value: string) => void;
  autoFocus?: boolean;
}

export const MissionListSearchInput: React.FC<MissionListSearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search mission",
  onSearch,
  autoFocus = false,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && onSearch) {
      onSearch(value);
    }
  };

  const handleIconClick = () => {
    if (onSearch) onSearch(value);
  };

  return (
    <MissionListActionsSearchContainer>
      <MissionListActionsStateOverlay />
      <MissionListActionsSearchIconWrapper
        onClick={handleIconClick}
        style={{ cursor: onSearch ? "pointer" : "default" }}
      >
        <MissionListActionsSearchBox>
          <MissionListActionsSearchIconShape>
            <SearchIcon />
          </MissionListActionsSearchIconShape>
        </MissionListActionsSearchBox>
      </MissionListActionsSearchIconWrapper>
      <MissionListActionsInputContent>
        <MissionListActionsInput
          value={value}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </MissionListActionsInputContent>
    </MissionListActionsSearchContainer>
  );
};
